import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "transaction-confirm-card" }
const _hoisted_2 = { class: "modal-title" }
const _hoisted_3 = { class: "mt-2 d-flex ga-1 align-center justify-end" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = ["textContent"]

import { storeToRefs } from "pinia";
import { useTransactionConfirmModal } from "@/stores/transactionConfirmModal";


export default /*@__PURE__*/_defineComponent({
  __name: 'DefaultTransactionConfirm',
  setup(__props) {

const { modalData } = storeToRefs(useTransactionConfirmModal());

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("dialogs.transactionConfirm.continue-in-wallet")), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_btn, {
            variant: "text",
            size: "large",
            color: "rgba(255, 255, 255, 0.5)",
            class: "text-uppercase",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(modalData).reject && _unref(modalData).reject()))
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                textContent: _toDisplayString(_ctx.$t('common.cancel'))
              }, null, 8, _hoisted_4)
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            color: "primary",
            size: "large",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(modalData).confirm && _unref(modalData).confirm()))
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                textContent: _toDisplayString(_ctx.$t('common.confirm'))
              }, null, 8, _hoisted_5)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})